import { Duration } from 'luxon';
export interface ImportPlanRequest {
    productionDate? : Duration
}
